import { Config } from '@/config/index';

export const overrideConfig: Partial<Config> = {
  firebase: {
    apiKey: 'AIzaSyB-x8gFuVKzbIoB1aYKbG1jrvm8mbZUmkQ',
    authDomain: 'mindx-edu-dev.firebaseapp.com',
    databaseURL: 'https://mindx-edu-dev.firebaseio.com',
    projectId: 'mindx-edu-dev',
    storageBucket: 'mindx-edu-dev.appspot.com',
    messagingSenderId: '592744290445',
    appId: '1:592744290445:web:aa82213d363f9b59c5eac4',
    measurementId: 'G-QPEELWB8Q4',
  },
  base: {
    webUrl: 'https://base-dev.mindx.edu.vn',
    apiUrl: 'https://gateway-staging.mindx.edu.vn/base-api-dev/graphql',
    baseUrl: 'https://base-api-dev.mindx.edu.vn',
    rootEndpoint: 'https://resources-dev.mindx.edu.vn',
    uploadEndpoint: 'https://resources-dev.mindx.edu.vn/api/v1/resources',
    imageEndpoint: 'https://resources-dev.mindx.edu.vn/uploads/images',
    templateSource: '/uploads/documents/File update TMS -1723549263903-3516.xlsx',
  },
  socketService: {
    main: 'ws://localhost:30916',
    url: 'wss://noti-dev.mindx.edu.vn',
  },
  powerbiUrl: {
    link: 'app.powerbi.com',
    group: 'groups',
    report: 'report',
  },
  regex: {
    username: /^[a-zA-Z0-9\-.]{5,50}$/,
    email: /^[a-z0-9][a-z0-9_.]{0,40}@[a-z0-9]{2,}(.[a-z0-9]{2,4}){1,2}$/,
    phone: /^(\+84)([0-9]){9}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,20}$/,
    url: new RegExp(
      [
        'https?://',
        '([a-zA-Z0-9-]+.)?',
        '(mindx.edu.vn|mindx.vn|mindx.com.vn|mindxspace.com)',
        '(/[-a-zA-Z0-9()@:%_+.~#?&//=]*)?',
      ].join(''),
    ),
  },
  i18n: {
    VI: 'vi',
    EN: 'en',
    defaultLang: 'vi',
  },
};
